import axios from "axios";
import { API_URL } from "src/scenes/App";

const authHeaders = (token) => ({
    headers: {
        Authorization: "Bearer " + token
    }
});

export const getUserTags = (token) => axios.get(`${API_URL}/userTags`, authHeaders(token));

export const createUserTag = (token, name) => axios.post(
    `${API_URL}/userTags`,
    { name },
    authHeaders(token)
);

export const updateUserTag = (token, tagUuid, name) => axios.put(
    `${API_URL}/userTags/${tagUuid}`,
    { name },
    authHeaders(token)
);

export const deleteUserTag = (token, tagUuid) => axios.delete(
    `${API_URL}/userTags/${tagUuid}`,
    authHeaders(token)
);

export const updateUserTagAssignments = (token, employeeUuids, tagUuids) => axios.put(
    `${API_URL}/userTags/assignments`,
    { employeeUuids, tagUuids },
    authHeaders(token)
);
